import { Waypoint } from "react-waypoint"
import { useToggle } from "@lib/hooks"
import { IconArrowUp } from "@lib/icons"

import type { ReactElement } from "react"

interface DocumentTemplateProps {
  children: ReactElement | ReactElement[]
  sidebar?: ReactElement | null
}

export function DocumentTemplate(props: DocumentTemplateProps) {
  const { children, sidebar } = props
  const { opened, open, close } = useToggle()

  function buttonUpClickHandler() {
    if (opened) {
      document.querySelector("main")?.scrollTo({
        top: 0,
      })
    }
  }

  return (
    <div className="relative">
      <Waypoint onEnter={close} />
      <div className="absolute -z-1 top-[130vh]">
        <Waypoint onEnter={open} />
      </div>

      <div className="space-y-8 laptop:space-y-0 laptop:flex laptop:items-start">
        {sidebar ? (
          <aside className="hidden laptop:block sticky z-1 top-0 -mt-4 pt-4 w-full flex-shrink-0 bg-white laptop:w-92 laptop:order-2 desktop:w-117">
            {sidebar}
          </aside>
        ) : null}
        <div className="laptop:pr-15 laptop:order-1">{children}</div>
      </div>

      <div className="fixed z-2 right-0 bottom-0 pr-6 pb-6 laptop:pr-8 laptop:pb-8">
        <button
          className="w-12 h-12 inline-flex items-center justify-center text-3xl text-white bg-black rounded-full"
          onClick={buttonUpClickHandler}
          style={{ display: opened ? "flex" : "none" }}
        >
          <IconArrowUp className="w-7 h-7" />
        </button>
      </div>
    </div>
  )
}
